import { Text, Box, Button } from '@chakra-ui/react';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Store } from '../../store';
import { clearIntroFields, getIntroField } from '../../utils';
import { SubstitutableLabels } from 'src/utils/labels';
import { posthog } from 'posthog-js';
import { closeWidget } from '../ChatHeader';
import { useVendor } from '@outdoorly/react-chat-sdk';

type AdditionalIntroPromptingProps = {
  submitMessage: () => void;
};

export const AdditionalIntroPrompting: React.FC<AdditionalIntroPromptingProps> = (props) => {
  const { submitMessage } = props;
  const labels = Store.useState((s) => s.labels);
  return (
    <>
      <Box mb="12px">
        <Text variant="paragraph-medium" color="scheme.contentPrimary">
          {labels.continueToChatPrompt}
        </Text>
      </Box>

      <ContinueToChatButton onClick={submitMessage} labels={labels} />
    </>
  );
};

const ContinueToChatButton = ({ labels, onClick }: { labels: SubstitutableLabels; onClick: () => void }) => {
  const [buttonDisabled, setButtonDisabled] = useState(
    Boolean(getIntroField('introMessage-35b1b789-6b6f-4a79-a5e6-ec1f9bea705b'))
  );
  const continueChatButtonRef = useRef<null | HTMLButtonElement>(null);
  const isActivatorOpen = Store.useState((s) => s.activatorVisible);
  const { vendor } = useVendor();
  const supportLink = useMemo(() => {
    if (!vendor?.supportLink) return '/';
    const supportUrl = new URL(vendor.supportLink);
    supportUrl.searchParams.set('utm_source', 'remark');
    supportUrl.searchParams.set('utm_medium', 'chat');
    return supportUrl.toString();
  }, [vendor?.supportLink]);
  useEffect(() => {
    if (continueChatButtonRef && continueChatButtonRef.current && !buttonDisabled && !isActivatorOpen) {
      setTimeout(() => continueChatButtonRef?.current?.focus(), 200);
    }
  }, [continueChatButtonRef, buttonDisabled, isActivatorOpen]);

  return (
    <>
      <Button
        variant="submit-cta"
        isDisabled={buttonDisabled}
        onClick={() => {
          posthog.capture('SUPPORT-LINK-BUTTON');
          clearIntroFields();
          closeWidget();
          window.open(supportLink);
        }}
        tabIndex={0}
        ref={continueChatButtonRef}
      >
        {labels.customerServicePromptButton}
      </Button>
      <Text
        _hover={{ textDecoration: 'underline' }}
        cursor="pointer"
        variant="label-small"
        color="scheme.contentTertiary"
        onClick={() => {
          onClick();
          setButtonDisabled(true);
          posthog.capture('CONTINUE-AFTER-ADDITIONAL-PROMPTING');
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            onClick();
            setButtonDisabled(true);
            posthog.capture('CONTINUE-AFTER-ADDITIONAL-PROMPTING');
          }
        }}
        textAlign="center"
        mt="12px"
        tabIndex={0}
      >
        {labels.continueAfterPrompting}
      </Text>
    </>
  );
};
